import { Link } from "react-router-dom";
import type { Tip } from "@/types/content";

export default function RelatedTips({ list }: { list: Tip[] }) {
  if (list.length === 0) return null;

  return (
    <section aria-label="相关爆料推荐" className="mt-12">
      <h2 className="font-display text-xl text-foreground-950 md:text-2xl">你可能也关心</h2>
      <ul className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {list.map((tip) => (
          <li key={tip.id} className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
            <Link to={`/detail/${tip.id}`} className="flex h-full flex-col">
              <span className="h-32 w-full overflow-hidden bg-background-200">
                <img
                  src={tip.cover}
                  alt={`${tip.title} 爆料配图`}
                  title={`${tip.title} - 爆料专区相关内容`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="flex flex-1 flex-col p-4">
                <span className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {tip.title}
                </span>
                <span className="mt-auto pt-3 font-label text-xs text-foreground-500">
                  {tip.author} · {tip.likes} 赞
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}